import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { SiteConfigManager } from '@atlas/core';
import { EmptyStateView } from '@atlas/ui';

import BonusListItem from 'components/ClientProfile/Bonuses/DepositBonuses/Bonus/BonusListItem';

const BonusTable = ({ activateBonus, activeBonuses, bonuses, deactivateBonus, wallet }) => {
  const isSortBonusesEnabled = SiteConfigManager.getConfig('config.config.general.sortBonuses');

  const allBonuses = useMemo(() => {
    const bonusList = [
      ...activeBonuses.map(
        ({
          bonus,
          bonusAmount,
          createTime,
          currency,
          id,
          requiredWagering,
          status,
          wagerStartTime,
          wageredBets,
          wagering,
        }) => ({
          ...bonus,
          bonusAmount,
          createTime,
          currency,
          id,
          requiredWagering,
          status,
          wagerStartTime,
          wageredBets,
          wagering,
        }),
      ),
      ...bonuses,
    ];

    if (isSortBonusesEnabled) {
      return [
        ...bonusList.filter(el => el?.status === 'ACTIVATED'),
        ...bonusList.filter(el => el?.status === 'IN_PROGRESS'),
        ...bonusList.filter(el => el?.status === 'PENDING'),
        ...bonusList.filter(el => el?.bonusStatus === 'ACTIVE' && !el.status),
      ];
    }

    return [
      ...bonusList.filter(el => el?.status === 'ACTIVATED'),
      ...bonusList.filter(el => el?.status === 'IN_PROGRESS'),
      ...bonusList.filter(el => el?.status === 'PENDING'),
      ...bonusList.filter(el => el?.bonusStatus === 'ACTIVE' && !el.status),
      ...bonusList.filter(el => el?.status === 'EXPIRED'),
      ...bonusList.filter(el => el?.status === 'COMPLETED'),
      ...bonusList.filter(el => el?.status === 'CANCELED'),
      ...bonusList.filter(el => el?.status === 'SPEND'),
      ...bonusList.filter(el => el?.status === 'DISABLED'),
      ...bonusList.filter(el => el?.status === 'ACTIVATION_EXPIRED'),
    ];
  }, [activeBonuses, bonuses, isSortBonusesEnabled]);

  if (allBonuses.length === 0) {
    return (
      <EmptyStateView
        className="empty-center"
        description="bonus_empty_message"
        title="bonus_empty_title"
      />
    );
  }

  return (
    <div className="bonus-history-list">
      {allBonuses.map(bonus => (
        <BonusListItem
          activateBonus={activateBonus}
          bonus={bonus}
          deactivateBonus={deactivateBonus}
          key={bonus.id}
          wallet={wallet}
        />
      ))}
    </div>
  );
};

BonusTable.propTypes = {
  activateBonus: PropTypes.func.isRequired,
  activeBonuses: PropTypes.array.isRequired,
  bonuses: PropTypes.array.isRequired,
  deactivateBonus: PropTypes.func.isRequired,
  wallet: PropTypes.object.isRequired,
};

export default BonusTable;
